module.exports = __webpack_public_path__ + "media/images/logo/lsp-742dfbffb8b04d4bd187df1dfe20b4a0.png";